export const CookieTypes = {
  Analytical: "ANALYTICAL",
  Promotional: "PROMOTIONAL",
  Preferences: "PREFERENCES"
};

export const CookiesArr = ["analyticalCookies", "promotionalCookies", "preferencesCookies"];
